<template>
  <div class="d-flex" v-if="parent && value && value.length > 0">
    <text-group
      v-for="(v, i) in value"
      :key="i"
      class="ml-20px"
      :utext="v"
      :btext="parent[v]"
    />
    <v-btn small class="ml-5 btn-primary" @click="parent.log"
      >log formControls</v-btn
    >
  </div>
</template>
<script>
import TextGroup from './TextGroup';

export default {
  components: { TextGroup },
  props: {
    parent: Object,
    value: Array,
  },
};
</script>
